import * as React from 'react';

import { trackSubscribed } from './tracking';
import { SaveSearchContainer, useSaveSearchEvents, TOnSubmitSaveSearchParams } from '../../../packages/SaveSearchModal';

const handleOnSubscribed = ({ frequency, subscribeToNews }: TOnSubmitSaveSearchParams) => {
  trackSubscribed({ frequency, subscribeToNews });

  /* istanbul ignore next */
  if (window.__reloadHeader__) {
    window.__reloadHeader__();
  }
};

export const SaveSearchEventsContainer: React.FC = () => {
  useSaveSearchEvents(handleOnSubscribed);

  return <SaveSearchContainer />;
};
